/**
 * Admission-module settings API.
 *
 * Per-org admission settings:
 *   - enable_admission_module: master on/off (default false → app behaves as today)
 *   - deposit_low_threshold_paise: the DEPOSIT_LOW alarm headroom (C4 / C-8),
 *     integer paise >= 0, default 0 ("alert as soon as the bill exceeds deposits")
 *   - bed_day_accrual_enabled: automatic nightly bed-day charging on/off
 *     (default false — bed charges are added manually until an admin flips it on)
 *
 * Backend: GET / PUT /api/organisation/settings/admission
 * PUT is a partial update — an omitted field keeps its current value.
 */
import apiClient from './apiClient';

export const getAdmissionSettings = async () => {
  const res = await apiClient.get('/api/organisation/settings/admission');
  return res.data;
};

/**
 * Partial update. Pass only the fields you're changing; omitted fields keep
 * their server value (C-8 partial-update convention). Money on the wire =
 * integer paise.
 *   patch: { enable_admission_module?: bool, deposit_low_threshold_paise?: int, bed_day_accrual_enabled?: bool }
 */
export const updateAdmissionSettings = async (patch = {}) => {
  const body = {};
  if (patch.enable_admission_module != null) body.enable_admission_module = !!patch.enable_admission_module;
  if (patch.deposit_low_threshold_paise != null) body.deposit_low_threshold_paise = Math.max(0, Math.round(patch.deposit_low_threshold_paise));
  if (patch.bed_day_accrual_enabled != null) body.bed_day_accrual_enabled = !!patch.bed_day_accrual_enabled;
  const res = await apiClient.put('/api/organisation/settings/admission', body);
  return res.data;
};
